/**
 * Round Type Plugin System
 * Central registration point for all round type handlers
 */

import { roundTypeRegistry } from './RoundTypeRegistry'
import { multipleChoiceHandler } from './mc'
import { classicQAHandler } from './qa'

/**
 * Initialize and register all round type plugins
 * Call this once during app initialization
 */
export function initializeRoundTypes(): void {
  // Register built-in round types
  roundTypeRegistry.register(classicQAHandler)
  roundTypeRegistry.register(multipleChoiceHandler)

  console.log(`✓ Initialized ${roundTypeRegistry.size} round type(s):`, roundTypeRegistry.getTypes())
}

// Auto-initialize on module load
initializeRoundTypes()

// Re-export everything for convenience
export { roundTypeRegistry, getRoundTypeHandlerSafe, supportsCapability } from './RoundTypeRegistry'
export type {
  RoundTypeHandler,
  RoundTypeCapabilities,
  RoundInfo,
  ModeratorViewProps,
  TeamViewProps,
  ModeratorViewEvents,
  TeamViewEvents
} from './RoundTypeHandler'
export { multipleChoiceHandler } from './mc'
export { classicQAHandler } from './qa'
